// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "._decoration_underline,tr:hover .emd-link{text-decoration:underline}@media (min-width:1920px){.el-main__content.el-main__content_xl{max-width:1920px;margin:0 auto}}", ""]);
// Exports
module.exports = exports;
